module.exports = __webpack_public_path__ + "img/emoji-saddest-on.182d0bd0.svg";